import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { useEffect, useState } from "react";

export const useFilterViewOurNodeMachineHook = () => {
  const machineStructureNodeset = getMachineStructureNodeset();

  const [flatArray, setFlatArray] = useState(
    Array.from(machineStructureNodeset.getFilteredFlatMap().values()),
  );

  useEffect(() => {
    const updateFlatMap = () => {
      const newFlatMap = machineStructureNodeset.getFilteredFlatMap();
      setFlatArray(Array.from(newFlatMap.values()));
    };

    machineStructureNodeset.addObserver(updateFlatMap);

    return () => {
      machineStructureNodeset.removeObserver(updateFlatMap);
    };
  }, [machineStructureNodeset]);

  return {
    data: Array.from(machineStructureNodeset.getFilteredFlatMap().values()),
  };
};
